import { domainUrl } from '../constants';

export const API_GET_STATUS = `${domainUrl}statuses`;
export const API_POST_SUB_STATUS = `${domainUrl}statuses`;
export const API_GET_SUB_STATUS = `${domainUrl}statuses/sub-statuses`;
export const API_PUT_DELETE_SUB_STATUS = `${domainUrl}statuses/{id}`;
